import { render } from "./ProfileMini.vue?vue&type=template&id=a92dcd4a&scoped=true&ts=true"
import script from "./ProfileMini.vue?vue&type=script&lang=ts"
export * from "./ProfileMini.vue?vue&type=script&lang=ts"

import "./ProfileMini.vue?vue&type=style&index=0&id=a92dcd4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a92dcd4a"]])

export default __exports__